import { render } from "./wxmp-bot.vue?vue&type=template&id=2617c2ee&ts=true"
import script from "./wxmp-bot.vue?vue&type=script&lang=ts"
export * from "./wxmp-bot.vue?vue&type=script&lang=ts"

import "./wxmp-bot.vue?vue&type=style&index=0&id=2617c2ee&lang=scss"

import exportComponent from "/srv/bimgx-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__